<mat-dialog-content class="dialog-content">
  <div class="dialog-header">
    <h3>Reward Points</h3>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-body">
    <p *ngIf="this.membership?.availablePoints > 0">You have enough points for a discount. Would you like to redeem them now?</p>
    <p *ngIf="this.membership?.availablePoints == 0">You do not have enough points for a discount!</p>
    <div class="points-balance">
      <span class="points">RM {{this.membership?.availablePoints | number: '1.2-2'}}</span>
      <span class="balance-text">Points Balance</span>
    </div>
    <div class="rewards-discount">
      <span>Rewards Discount</span>
      <span class="discount-amount" *ngIf="this.membership?.availablePoints > total">- RM {{total | number: '1.2-2'}}
        <span style="color: #00a60d;">
         (Point Balance: {{getFormattedPoints()}})
        </span>
      </span>

      <span class="discount-amount" *ngIf="this.membership?.availablePoints <= total">- RM {{this.membership?.availablePoints | number: '1.2-2'}}
        <span style="color: #00a60d;">
         (Point Balance: 0.00)
        </span>
      </span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex justify-content-center w-100 p-3">
    <div class="col-4 me-3">
      <button class="btn btn-default border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="col-8" role="button" (click)="submit()">
      <button
        [disabled]="this.membership?.availablePoints > 0 ? false : true"
        class="btn btn-default bg-primary text-white w-100 h-100 d-flex align-items-center justify-content-center">
        <i class="fa fa-check-circle me-2"></i>
        <span class="me-2">Cashback Redeem</span><span> (RM {{redeemPoints | number: '1.2-2'}})</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
